/* CEIKA legacy product financing: mirror one settled displayed USD total. */
(function (global) {
  'use strict';
  if (global.CeikaLegacyFinancing) { global.CeikaLegacyFinancing.scan(); return; }
  const controllers = new Set(), instances = new WeakMap();
  let messageId = 0;

  function parseUsdAmount(value) {
    if (typeof value !== 'string') return null;
    let text = value.replace(/[\u200e\u200f\u202a-\u202e\u2066-\u2069]/g, '')
      .replace(/[\u0660-\u0669]/g, x => String(x.charCodeAt(0) - 0x0660))
      .replace(/[\u06f0-\u06f9]/g, x => String(x.charCodeAt(0) - 0x06f0))
      .replace(/\u066b/g, '.').replace(/\u066c/g, ',')
      .replace(/[\u00a0\u202f]/g, ' ').trim();
    if (!/(?:USD|\$)/i.test(text) || (text.match(/\$/g) || []).length > 1 ||
        (text.match(/\bUSD\b/gi) || []).length > 1) return null;
    text = text.replace(/US\$|\bUSD\b|\$/gi, '').trim();
    const parts = /^(.+)([.,])([0-9]{2})$/.exec(text);
    if (!parts) return null;
    let integer = parts[1];
    if (!/^[0-9]+$/.test(integer)) {
      const separators = [...new Set(integer.match(/[., ]/g) || [])];
      if (separators.length !== 1 || separators[0] === parts[2]) return null;
      const separator = separators[0], escaped = separator === '.' ? '\\.' : separator;
      if (!(new RegExp('^[0-9]{1,3}(?:' + escaped + '[0-9]{3})+$')).test(integer)) return null;
      integer = integer.split(separator).join('');
    }
    const amount = Number(integer) * 100 + Number(parts[3]);
    return Number.isSafeInteger(amount) && amount > 0 ? amount : null;
  }

  class Controller {
    constructor(marker, env = global) {
      this.env = env; this.marker = marker; this.scope = marker.closest('.product_section');
      this.revision = 0; this.timer = null; this.amount = null; this.awaitingPrice = false;
      this.pendingReady = null; this.publishedState = null; this.disposed = false; this.lastPriceNode = null;
      this.abort = new env.AbortController();
      this.clear();
      if (!this.scope) { this.disposed = true; return; }
      const options = {capture: true, signal: this.abort.signal};
      this.scope.addEventListener('input', e => this.interaction(e), options);
      this.scope.addEventListener('change', e => this.interaction(e), options);
      this.scope.addEventListener('click', e => this.interaction(e), options);
      this.observer = new env.MutationObserver(records => this.mutations(records));
      this.observer.observe(this.scope, {subtree: true, childList: true, characterData: true,
        attributes: true, attributeOldValue: true,
        attributeFilter: ['class', 'hidden', 'aria-busy', 'aria-checked', 'data-price', 'data-amount', 'data-product-id', 'data-country', 'data-currency']});
      this.interval = env.setInterval(() => this.poll(), 750);
      this.schedule();
    }

    eligible() {
      const shopify = this.env.Shopify;
      return !this.disposed && this.marker.isConnected && this.scope?.isConnected &&
        this.marker.dataset.country === 'US' && this.marker.dataset.currency === 'USD' &&
        shopify?.country === 'US' && (!shopify.currency?.active || shopify.currency.active === 'USD');
    }

    visible(node) {
      for (let el = node; el; el = el.parentElement) {
        const style = this.env.getComputedStyle(el);
        if (el.hidden || style.display === 'none' || style.visibility === 'hidden') return false;
        if (el === this.scope) return true;
      }
      return false;
    }

    optionContainers() {
      return [...this.scope.querySelectorAll('.bold_options')].filter(el =>
        el.closest('.product_section') === this.scope &&
        el.dataset.productId === this.marker.dataset.productId);
    }

    allOptionContainers() {
      return [...this.scope.querySelectorAll('.bold_options')].filter(el =>
        el.closest('.product_section') === this.scope);
    }

    priceNodes() {
      const containers = this.allOptionContainers();
      const selector = containers.length ? '.bold_option_price_display' : '.price-ui [data-price]';
      return [...this.scope.querySelectorAll(selector)].filter(el =>
        el.closest('.product_section') === this.scope && this.visible(el));
    }

    read() {
      if (!this.eligible()) return null;
      const containers = this.optionContainers();
      const all = this.allOptionContainers();
      const required = this.marker.dataset.optionsRequired !== 'false';
      if ((required && (all.length !== 1 || containers.length !== 1)) ||
          (all.length && (all.length !== 1 || containers.length !== 1)) || containers.some(el => !el.classList.contains('bold_options_loaded') ||
          el.getAttribute('aria-busy') === 'true')) return null;
      const nodes = this.priceNodes();
      if (nodes.length !== 1) return null;
      this.lastPriceNode = nodes[0];
      return parseUsdAmount(nodes[0].textContent);
    }

    fingerprint() {
      return JSON.stringify([...this.scope.querySelectorAll('input,select,textarea,[role="checkbox"],[role="radio"]')]
        .filter(el => el.closest('.product_section') === this.scope && !this.marker.contains(el))
        .map(el => [el.name, el.type, el.value, Boolean(el.checked), el.disabled,
          el.getAttribute('aria-checked'), el.classList.contains('bold_swatch_selected')]));
    }

    clear() {
      this.marker.hidden = true; this.amount = null; this.pendingReady = null; this.publishedState = null;
      const p = this.marker.ownerDocument.createElement('p');
      p.dataset.ceikaLegacyFinanceMessage = ''; p.dataset.pageType = 'product';
      p.id = 'ceika-legacy-finance-' + (++messageId);
      this.marker.replaceChildren(p); this.message = p;
    }

    invalidate() {
      this.revision++;
      this.env.clearTimeout(this.timer); this.timer = null;
      this.clear();
    }

    interaction(event) {
      const target = event.target?.nodeType === 1 ? event.target : event.target?.parentElement;
      if (!target || target.closest('.product_section') !== this.scope) return;
      const option = target.closest('input,select,textarea,label,[role="checkbox"],[role="radio"]');
      if (!option) return;
      const bold = option.closest('.bold_options');
      if ((bold && this.optionContainers().includes(bold)) || option.name === 'id') {
        this.awaitingPrice = true; this.invalidate();
      }
    }

    mutations(records) {
      if (this.disposed) return;
      let fresh = false, readyChange = false, selectionChanged = false;
      const nodes = this.priceNodes();
      for (const record of records) {
        if (this.marker.contains(record.target) || record.target === this.marker) {
          if (record.target === this.marker && ['data-country', 'data-currency'].includes(record.attributeName)) this.invalidate();
          if (record.target === this.message && record.attributeName === 'data-amount' &&
              this.amount !== null && this.message.dataset.amount !== String(this.amount)) this.schedule();
          continue;
        }
        if ((record.type === 'characterData' || record.type === 'childList') &&
            nodes.some(node => node === record.target || node.contains(record.target))) fresh = true;
        if (record.type === 'childList') {
          const changed = [...record.addedNodes, ...record.removedNodes];
          if (changed.some(el => nodes.some(node => el === node || el.contains?.(node)) ||
              (this.lastPriceNode && (el === this.lastPriceNode || el.contains?.(this.lastPriceNode))))) fresh = true;
        }
        if (this.optionContainers().some(el => el === record.target || el.contains(record.target))) readyChange = true;
        if (this.allOptionContainers().some(el => el.contains(record.target))) {
          if (record.attributeName === 'aria-checked') selectionChanged = true;
          if (record.attributeName === 'class' &&
              /(?:^|\s)bold_swatch_selected(?:\s|$)/.test(record.oldValue || '') !==
              record.target.classList.contains('bold_swatch_selected')) selectionChanged = true;
        }
      }
      if (fresh) { this.awaitingPrice = false; this.schedule(); }
      else if (selectionChanged) { this.awaitingPrice = true; this.invalidate(); }
      else if (readyChange && !this.awaitingPrice) this.schedule();
    }

    schedule() {
      if (this.disposed) return;
      this.invalidate();
      if (this.awaitingPrice) return;
      const revision = this.revision;
      this.timer = this.env.setTimeout(() => this.commit(revision), 180);
    }

    valid(revision, amount, state) {
      return !this.awaitingPrice && revision === this.revision && this.eligible() &&
        this.read() === amount && this.fingerprint() === state;
    }

    commit(revision) {
      this.timer = null;
      if (revision !== this.revision || this.awaitingPrice) return;
      const amount = this.read(), state = this.fingerprint(), ui = this.env.affirm?.ui;
      if (amount === null || typeof ui?.ready !== 'function' || typeof ui.refresh !== 'function') return;
      this.pendingReady = {revision, amount, state};
      try {
        ui.ready(() => {
          if (!this.valid(revision, amount, state)) {
            if (revision === this.revision && !this.disposed) { this.awaitingPrice = true; this.invalidate(); }
            return;
          }
          this.pendingReady = null; this.amount = amount; this.publishedState = state;
          this.message.dataset.amount = String(amount);
          this.message.classList.add('affirm-as-low-as'); this.marker.hidden = false;
          try { ui.refresh(); } catch (_) { this.invalidate(); }
        });
      } catch (_) { this.invalidate(); }
    }

    poll() {
      if (!this.marker.isConnected || !this.scope?.isConnected) { this.dispose(); return; }
      const amount = this.read();
      const state = this.fingerprint();
      if ((this.amount !== null && state !== this.publishedState) ||
          (this.pendingReady && state !== this.pendingReady.state)) {
        this.awaitingPrice = true; this.invalidate(); return;
      }
      if (amount === null) {
        if (this.amount !== null || !this.marker.hidden) this.invalidate();
        return;
      }
      if (this.awaitingPrice) return;
      if (this.pendingReady?.revision === this.revision && this.pendingReady.amount === amount &&
          this.pendingReady.state === this.fingerprint()) return;
      if (this.amount !== amount || this.message.dataset.amount !== String(amount)) this.schedule();
    }

    dispose() {
      if (this.disposed) return;
      this.invalidate(); this.disposed = true;
      this.abort.abort(); this.observer?.disconnect(); this.env.clearInterval(this.interval);
      controllers.delete(this);
    }
  }

  function scan() {
    if (!global.document) return;
    global.document.querySelectorAll('[data-ceika-legacy-finance]').forEach(marker => {
      if (instances.get(marker) && !instances.get(marker).disposed) return;
      const controller = new Controller(marker);
      instances.set(marker, controller);
      if (!controller.disposed) controllers.add(controller);
    });
  }
  global.CeikaLegacyFinancing = {parseUsdAmount, Controller, scan};
  if (!global.document) return;
  global.document.addEventListener('change', event => {
    if (event.target?.matches?.('[name="country_code"],[name="currency_code"],[name="language_code"]')) {
      controllers.forEach(c => { c.awaitingPrice = true; c.invalidate(); });
    }
  }, true);
  global.document.addEventListener('shopify:section:load', scan);
  global.document.addEventListener('shopify:section:unload', event => {
    [...controllers].forEach(c => { if (event.target?.contains?.(c.marker)) c.dispose(); });
  });
  global.addEventListener('pagehide', () => [...controllers].forEach(c => c.dispose()));
  global.addEventListener('pageshow', scan);
  if (global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', scan, {once: true});
  else scan();
})(typeof window === 'undefined' ? globalThis : window);
